import type { Dispatch, SetStateAction } from "react";

import { Pagination, PaginationInput } from "@similarweb/ui-components";

import {
    SERPWidgetCloseIconButton,
    SerpWidgetTableTitleContainer,
    SerpWidgetTableTitleText,
    SWReactTableOptimizedStyled,
    WidgetTableWrapper,
} from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/StyledComponents";
import type { IRecord, SERPRecords } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/types";
import { SWReactTableOptimized } from "app/components/React/Table/SWReactTableOptimized";
import { SWReactTableWrapperFooter } from "app/components/React/Table/SWReactTableWrapper";
import { i18nFilter } from "app/filters/i18nFilter";
import type { SERP_IDS } from "app/pages/website-analysis/traffic-sources/search/components/serp/SerpTypes";
import { SERP_MAP } from "app/pages/website-analysis/traffic-sources/search/components/serp/SerpTypes";
import type { ISortDirection } from "app/@types/userdata";

import { ITEMS_PER_PAGE, SERPWithoutWebsites } from "../../consts";

export const SerpTileTable = ({
    selectedSerpFeatureName,
    setSelectedSerpFeatureName,
    serpRecords,
    pageDataChunks,
    page,
    widgetColumns,
    onSort,
    showPagination,
    onPageChange,
}: {
    selectedSerpFeatureName: string;
    setSelectedSerpFeatureName: Dispatch<SetStateAction<"" | SERP_IDS>>;
    serpRecords: SERPRecords;
    pageDataChunks: IRecord[][];
    page: number;
    widgetColumns: unknown[];
    onSort: ({ sortDirection }: { sortDirection: ISortDirection }) => void;
    showPagination: boolean;
    onPageChange: (selectedPage: number) => void;
}) => {
    return (
        <WidgetTableWrapper>
            <SWReactTableOptimizedStyled>
                <SerpWidgetTableTitleContainer>
                    <SerpWidgetTableTitleText>
                        {SERPWithoutWebsites.includes(SERP_MAP[selectedSerpFeatureName].id)
                            ? i18nFilter()("serp.top.table.widget.table.results.title", {
                                  name: SERP_MAP[selectedSerpFeatureName].name,
                              })
                            : i18nFilter()("serp.top.table.widget.table.title", {
                                  name: SERP_MAP[selectedSerpFeatureName].name,
                              })}
                    </SerpWidgetTableTitleText>
                    <SERPWidgetCloseIconButton
                        type="flat"
                        onClick={() => setSelectedSerpFeatureName("")}
                        iconName="clear"
                        placement="left"
                        iconSize="xs"
                    />
                </SerpWidgetTableTitleContainer>
                <SWReactTableOptimized
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    tableData={{ Data: pageDataChunks[page], pageSize: ITEMS_PER_PAGE }}
                    tableColumns={widgetColumns}
                    onSort={onSort}
                    tableOptions={{}}
                />
                <SWReactTableWrapperFooter>
                    {showPagination ? (
                        <Pagination
                            page={page + 1}
                            itemsPerPage={ITEMS_PER_PAGE}
                            itemsCount={serpRecords[selectedSerpFeatureName as SERP_IDS].records.length}
                            handlePageChange={onPageChange}
                            captionElement={PaginationInput}
                            hasItemsPerPageSelect={false}
                        />
                    ) : null}
                </SWReactTableWrapperFooter>
            </SWReactTableOptimizedStyled>
        </WidgetTableWrapper>
    );
};
